import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  DatePicker,
  Select,
  Upload,
  Flex,
  message,
  Button,
} from "antd";
import {
  FileTextOutlined,
  DeleteOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import dayjs from "dayjs";
import orderService from "../../services/OrderLists";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
const { Dragger } = Upload;
const { Option } = Select;

const AddFeedback = ({
  orderData,
  handleTabChange,
  handleModalClose,
  fetchOrderDetails,
}) => {
  const [timezonesData, setTimeZonesData] = useState([]);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const FEEDBACK_CATEGORIES = [
    { value: 'feedback', label: 'Feedback' },
    { value: 'not_as_per_instructions', label: 'Work Not as Per Instructions' },
    { value: 'quality_improvement', label: 'Quality Improvement Required' },
    { value: 'additional_requirement', label: 'Additional Requirement / Scope Change' },
    { value: 'next_part', label: 'Next Part / Chapter Request' },
    { value: 'formatting_changes', label: 'Formatting Changes' },
  ];

  const [formData, setFormData] = useState({
    details: "",
    deadline_hard: orderData?.orderData?.data?.deadline_hard || "",
    timezone: "Asia/Kolkata",
    extra_word_count: "",
    files: [],
    category: "feedback",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [deadlineHard, setDeadlineHard] = useState(
    orderData?.orderData?.data?.deadline_hard
      ? dayjs(orderData.orderData.data.deadline_hard)
      : null
  );
  const [fileList, setFileList] = useState([]);
  const [description, setDescription] = useState("");
  const [form] = Form.useForm();
  const { orderKey } = useParams();
  const { user } = useSelector((state) => state.auth);
  const allowedUserTypes = [5, 10, 15];

  const deadlineDate = moment(orderData?.orderData?.data?.deadline_hard);

  // console.log(deadlineDate, "deadline");
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const timezoneData = await orderService.getTimezonesDropdown();
        setTimeZonesData(timezoneData.data);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };

    fetchDropdownData();
  }, []);
  const handleDescriptionChange = (value) => {
    setDescription(value);
    setFormData({ ...formData, details: value });
  };

  const handleFileChange = (info) => {
    setFileList(info.fileList);
  };

  const handleDeleteFile = (index) => {
    const newFileList = [...fileList];
    newFileList.splice(index, 1);
    setFileList(newFileList);
  };

  const getFormattedFileName = (fileName) => {
    const extensionIndex = fileName.lastIndexOf(".");
    const baseName =
      extensionIndex !== -1 ? fileName.substring(0, extensionIndex) : fileName;
    const extension =
      extensionIndex !== -1 ? fileName.substring(extensionIndex) : "";

    if (baseName.length > 14) {
      return {
        displayName: `${baseName.substring(0, 14)}...${extension}`,
        fullName: fileName,
      };
    }
    return {
      displayName: fileName,
      fullName: fileName,
    };
  };

  const getFileIcon = (fileName) => {
    const extension = fileName?.split(".").pop().toLowerCase();
    switch (extension) {
      case "pdf":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/PDF_file_icon.svg.png";
      case "doc":
      case "docx":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/docx_icon.svg.png";
      case "jpg":
      case "jpeg":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/jpeg-jpg.png";
      case "png":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/png1.webp";
      case "zip":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/zipppp.png";
      case "ppt":
      case "pptx":
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/images_1.png";
      default:
        return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/file-file-type.svg";
    }
  };
  const handleSubmit = async () => {
    if (!formData.details) {
      message.error("Please provide Details.");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("details", formData.details);
    formDataToSend.append("deadline_hard", formData.deadline_hard);
    formDataToSend.append("extra_word_count", formData.extra_word_count);
    formDataToSend.append("timezone", formData.timezone);
    formDataToSend.append("category", formData.category || "feedback");
    fileList.forEach((file) =>
      formDataToSend.append("files", file.originFileObj)
    );
    console.log(formDataToSend, "formDataToSend");
    try {
      setIsLoading(true);
      const response = await orderService.addFeedback(orderKey, formDataToSend);

      if (response?.success) {
        message.success("Feedback submitted successfully.");
        fetchOrderDetails();
        handleModalClose();
        await handleTabChange("4");
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form form={form} layout="vertical" encType="multipart/form-data">
      <Flex
        vertical
        justify="center"
        style={{ width: "100%", paddingRight: "10px" }}
        gap={0}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Reason for Revision" required>
              <Select
                value={formData.category}
                onChange={(value) => setFormData({ ...formData, category: value })}
                style={{ width: "100%" }}
              >
                {FEEDBACK_CATEGORIES.map((cat) => (
                  <Option key={cat.value} value={cat.value}>{cat.label}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Description" required>
              <ReactQuill
                value={description}
                onChange={handleDescriptionChange}
                style={{ height: "150px" }}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link"],
                    ["clean"],
                  ],
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginTop: isMobile ? "0px" : "35px" }}>
          <Col lg={12}>
            <Form.Item label="Deadline Hard" required>
              <DatePicker
                value={deadlineHard}
                disabledDate={(current) =>
                  current && current.isBefore(moment().startOf("day"))
                }
                style={{ width: "100%" }}
                showTime
                format="YYYY-MM-DD HH:mm A"
                onChange={(date) => {
                  setDeadlineHard(date);
                  setFormData({
                    ...formData,
                    deadline_hard: date ? date.toISOString() : null,
                  });
                }}
              />
            </Form.Item>
          </Col>
          <Col style={{ marginTop: isMobile ? "50px" : 0 }} lg={12}>
            <Form.Item label="Timezone">
              <Select
                defaultValue="Asia/Kolkata"
                showSearch
                onChange={(value) =>
                  setFormData({ ...formData, timezone: value })
                }
              >
                {timezonesData.map((timezone) => (
                  <Option key={timezone} value={timezone}>
                    {timezone}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {allowedUserTypes.includes(user?.user?.type) && (
          <Row style={{ width: "100%" }}>
            <Form.Item label="Extra Word Count" style={{ width: "100%" }}>
              <Input
                placeholder="Enter extra word count"
                suffix={<FileTextOutlined />}
                value={formData.extra_word_count}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setFormData((prev) => ({
                      ...prev,
                      extra_word_count: value,
                    }));
                  } else {
                    message.warning("Only numeric values are allowed.");
                  }
                }}
              />
            </Form.Item>
          </Row>
        )}
        <Row>
          <label>Files</label>
          <div className="file-parent">
            <div className="file-container">
              {fileList.length === 0 ? (
                <Flex
                  vertical
                  justify="center"
                  style={{ width: "100%", minHeight: "150px" }}
                  className="file-preview-container"
                >
                  <Dragger
                    style={{
                      width: "100%",
                      background: "none",
                      border: "none",
                    }}
                    showUploadList={false} // Hide Ant Design's automatic file list
                    beforeUpload={() => false} // Prevent automatic upload
                    onChange={handleFileChange} // Handle file selection
                    fileList={fileList} // Set fileList state for controlled uploads
                    multiple // Allow multiple file uploads
                    listType="text" // Display file names below the input
                  >
                    <p
                      className="ant-upload-text "
                      style={{ color: "gray", marginTop: "20px" }}
                    >
                      Drag & drop files here or click to upload
                    </p>
                  </Dragger>
                </Flex>
              ) : (
                <div
                  className="file-preview-container"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {fileList.map((file, index) => {
                    const { displayName, fullName } = getFormattedFileName(
                      file.name
                    );

                    return (
                      <div
                        key={index}
                        className="file-preview-item"
                        style={{
                          margin: "10px",
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #d9d9d9",
                          padding: "2px 4px",
                          borderRadius: "4px",
                        }}
                      >
                        <img
                          style={{
                            height: "40px",
                            width: "40px",
                            marginRight: "8px",
                          }}
                          src={getFileIcon(file.name)}
                          alt="file-icon"
                        />
                        <span title={fullName}>{displayName}</span>
                        <DeleteOutlined
                          style={{ marginLeft: "8px", cursor: "pointer" }}
                          onClick={() => handleDeleteFile(index)} // Call delete function on click
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <Upload
              showUploadList={false} // Hide Ant Design's automatic file list
              beforeUpload={() => false} // Prevent automatic upload
              onChange={handleFileChange}
              fileList={fileList} // Set fileList state for controlled uploads
              multiple
              listType="text"
            >
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <PaperClipOutlined
                  style={{ fontSize: "24px", marginRight: "8px" }}
                />
              </div>
            </Upload>
          </div>
        </Row>

        <Flex style={{ width: "100%" }} justify="flex-end" align="flex-end">
          <Button type="primary" loading={isLoading} onClick={handleSubmit}>
            Submit
          </Button>
        </Flex>
        {/* <Row>
        <label>Files</label>
        <div className="file-container">
          {fileList.length === 0 ? (
            <Dragger
              style={{ width: "100%", minHeight: "150px" }}
              fileList={fileList}
              beforeUpload={() => false}
              onChange={handleFileChange}
              multiple>
              <p>Drag & drop files here or click to upload</p>
            </Dragger>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {fileList.map((file, index) => {
                const { displayName, fullName } = getFormattedFileName(
                  file.name
                );

                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #d9d9d9",
                      padding: "4px",
                      marginBottom: "5px",
                    }}>
                    <img
                      src={getFileIcon(file.name)}
                      alt="file-icon"
                      style={{ height: "40px", marginRight: "8px" }}
                    />
                    <span title={fullName}>{displayName}</span>
                    <DeleteOutlined
                      style={{ marginLeft: "auto", cursor: "pointer" }}
                      onClick={() => handleDeleteFile(index)}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Row> */}
      </Flex>
    </Form>
  );
};

export default AddFeedback;
